import React from 'react';
import { Segment, Divider, Button, Form, Icon, Message, Grid, Checkbox } from 'semantic-ui-react'
import PanelView from './subcomponents/PanelView'
import RequestView from './subcomponents/RequestView'

/**
 * Dashboard component
 */
export default class Dashboard extends React.Component {

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
            selectedVisitorTerritory: '-',
            selectedQueryType: '',
            activeView: 0,
            isDetailed: false
        }

        this.exportDataCache = {
            mode: '',
            leftRef: null,
            rightRef: null,
            data: []
        };
    }

    /**
	 * Initialize
	 */
	componentDidMount() {
        this.props.fetchUsers(this.props.profile.visitorTerritory);
    }

    /**
     * Get all panels or only one
     */
    fetchPanels = () => {

        this.setState({ ...this.state, activeView: 1, selectedQueryType: 'panel' });

        if (this.state.selectedVisitorTerritory === '-')
        {
            // All
            this.props.fetchAllPanel(this.props.profile.visitorTerritory);
        }
        else
        {
            // Visitor
            this.props.fetchPanel(this.state.selectedVisitorTerritory, this.state.isDetailed ? 'detailed' : undefined);
        }
    }

    /**
     * Fetch requests and changes
     */
    fetchChanges = () => {

        this.setState({ ...this.state, activeView: 2, selectedQueryType: 'changes' });

        if (this.state.selectedVisitorTerritory === '-')
        {
            // All
            this.props.fetchAllRequests(this.props.profile.visitorTerritory);
            this.props.fetchAllPanelChanges(this.props.profile.visitorTerritory);
        }
        else
        {
            // Visitor
            this.props.fetchRequests(this.state.selectedVisitorTerritory);
            this.props.fetchPanelChanges(this.state.selectedVisitorTerritory, this.state.isDetailed ? 'detailed' : undefined);
        }        
    }

    /**
     * Export data
     */
    getExportData = () => {
        if (this.state.selectedQueryType === 'panel')
        {
            return this.state.selectedVisitorTerritory === '-' ? this.props.allPanels : this.props.actualPanel;
        }

        const left = this.state.selectedVisitorTerritory === '-' ? this.props.allRequests : this.props.requests;
        const right = this.state.selectedVisitorTerritory === '-' ? this.props.allPanelChanges : this.props.panelChanges;
        const mode = this.state.selectedVisitorTerritory === '-' ? 'changes_all' : 'changes_single';

        if (
            this.exportDataCache.mode === mode &&
            this.exportDataCache.leftRef === left &&
            this.exportDataCache.rightRef === right
        ) {
            return this.exportDataCache.data;
        }

        this.exportDataCache = {
            mode: mode,
            leftRef: left,
            rightRef: right,
            data: left.concat(right)
        };

        return this.exportDataCache.data;
    }

    escapeCsvValue = (value) => {
        if (value === null || value === undefined) {
            return '""';
        }

        const normalized = typeof value === 'object' ? JSON.stringify(value) : String(value);
        return `"${normalized.replace(/"/g, '""')}"`;
    }

    buildCsvText = (rows) => {
        if (!Array.isArray(rows) || rows.length === 0) {
            return '';
        }

        if (Array.isArray(rows[0])) {
            return rows
                .map((row) => row.map((cell) => this.escapeCsvValue(cell)).join(','))
                .join('\n');
        }

        if (typeof rows[0] === 'object' && rows[0] !== null) {
            const firstKeys = Object.keys(rows[0]);
            const extraKeys = rows.reduce((acc, row) => {
                Object.keys(row || {}).forEach((key) => {
                    if (!acc.includes(key) && !firstKeys.includes(key)) {
                        acc.push(key);
                    }
                });
                return acc;
            }, []);
            const headers = firstKeys.concat(extraKeys);

            const csvRows = [
                headers.map((header) => this.escapeCsvValue(header)).join(',')
            ];

            rows.forEach((row) => {
                csvRows.push(headers.map((header) => this.escapeCsvValue(row[header])).join(','));
            });

            return csvRows.join('\n');
        }

        return rows.map((value) => this.escapeCsvValue(value)).join('\n');
    }

    handleExportClick = () => {
        const data = this.getExportData();
        const csvText = this.buildCsvText(data);

        if (!csvText) {
            return;
        }

        const filename = 'export_' + this.state.selectedQueryType + '_' + (this.state.selectedVisitorTerritory === '-' ? 'FULL' : this.state.selectedVisitorTerritory) + '.csv';
        const blob = new Blob(['\uFEFF' + csvText], { type: 'text/csv;charset=utf-8;' });
        const downloadLink = document.createElement('a');
        const url = URL.createObjectURL(blob);

        downloadLink.setAttribute('href', url);
        downloadLink.setAttribute('download', filename);
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
    }

	render() {
        // Requests
        let newRequestedTargetCount = 0;
        let deletedRequestedTargetCount = 0;
        let modifiedRequestedTargetCount = 0;
        let allRequestedTargetCount = 0;

        if (this.props.requests.length > 0 || this.props.panelChanges.length > 0)
        {
            newRequestedTargetCount = this.props.panelChanges.filter( pc => !pc.isProcessed).filter( pc => (pc.requestType === 'add')).length + this.props.requests.filter( r => !r.isProcessed).length;
            deletedRequestedTargetCount = this.props.panelChanges.filter( pc => !pc.isProcessed).filter( pc => (pc.requestType === 'remove')).length;
            modifiedRequestedTargetCount =  this.props.panelChanges.filter( pc => !pc.isProcessed).filter( pc => (pc.requestType === 'modify')).length;
            allRequestedTargetCount = this.props.requests.filter( r => !r.isProcessed).length + this.props.panelChanges.filter( pc => !pc.isProcessed).length;            
        }
        else if (this.props.allPanelChanges.length > 0 || this.props.allRequests.length > 0)
        {
            newRequestedTargetCount = this.props.allPanelChanges.filter( pc => !pc.isProcessed).filter( pc => (pc.requestType === 'add')).length + this.props.allRequests.filter( r => !r.isProcessed).length;
            deletedRequestedTargetCount = this.props.allPanelChanges.filter( pc => !pc.isProcessed).filter( pc => (pc.requestType === 'remove')).length;
            modifiedRequestedTargetCount =  this.props.allPanelChanges.filter( pc => !pc.isProcessed).filter( pc => (pc.requestType === 'modify')).length;
            allRequestedTargetCount = this.props.allRequests.filter( r => !r.isProcessed).length + this.props.allPanelChanges.filter( pc => !pc.isProcessed).length;            
        }

		return  <Segment basic loading={ this.props.isLoading }>
                    { this.props.errorRequest === undefined ? '' : <Message error>Hiba történt. { this.props.errorRequest }</Message> }								
                    { this.props.errorPanelChange === undefined ? '' : <Message error>Hiba történt. { this.props.errorPanelChange }</Message> }								
                    { this.props.errorPanel === undefined ? '' : <Message error>Hiba történt. { this.props.errorPanel }</Message> }
                    { this.props.errorUser === undefined ? '' : <Message error>Hiba történt. { this.props.errorUser }</Message> }
					<h3><Icon name='exchange'/> Látogatóid Panelváltoztatásai</h3>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Form>
                                    <Form.Dropdown 
                                        placeholder='Név szerint is kereshetsz'
                                        search
                                        selection
                                        onChange={ (e, {value}) => { this.setState({ ...this.state, selectedQueryType: '', selectedVisitorTerritory: value }); this.props.resetAll() } }
                                        defaultValue={ this.state.selectedVisitorTerritory }
                                        options={this.props.users}
                                        label='Látogató' />
                                    <Button onClick={ this.fetchPanels } color='blue' icon><Icon name='table'/> Panel</Button>
                                    <Button onClick={ this.fetchChanges } color='blue' icon><Icon name='exchange'/> Változtatások</Button>
                                    <Button disabled={ this.state.selectedQueryType === '' } onClick={ this.handleExportClick } floated='right' color='green' icon><Icon name='file excel' /> { this.state.selectedQueryType === 'panel' ? 'Panel' : 'Változás' } Export</Button>
                                </Form>
                                <br/>
                                {
                                    this.state.selectedVisitorTerritory === '-'
                                    ?
                                    ''
                                    :
                                    <Checkbox defaultChecked={this.state.isDetailed} onChange={ () => this.setState({ ...this.state, selectedQueryType: '', isDetailed: !this.state.isDetailed }) } label='Részletes panel, célpontok mutatása címenként' />
                                }
                            </Grid.Column>
                            {
                                this.state.selectedQueryType === 'changes'
                                ?                            
                                <Grid.Column width={4}>
                                    <h5>Elbírálatlan igények</h5>
                                    Új célpont: <b>{ newRequestedTargetCount }</b>
                                    <br/>
                                    Törölt célpont: <b>{ deletedRequestedTargetCount }</b>
                                    <br/>
                                    Módosított célpont: <b>{ modifiedRequestedTargetCount }</b>
                                    <br/>
                                    Összes kérés: <b>{ allRequestedTargetCount }</b>
                                </Grid.Column>
                                :
                                ''
                            }                      
                        </Grid.Row>
                    </Grid>
					<Divider/>
                    {
                        this.state.selectedQueryType === ''
                        ?
                        <center style={{ color: '#aaa' }}>Válassz egy látogatót és kattins arra a gombra, amelyik jelentés érdekel.</center>
                        :
                        this.state.selectedQueryType === 'changes'
                        ?
                        <RequestView requests={ this.props.requests } panelChanges={ this.props.panelChanges } allRequests={ this.props.allRequests } allPanelChanges={ this.props.allPanelChanges } />
                        :
                        this.state.selectedQueryType === 'panel'
                        ?
                        <PanelView allPanels={ this.props.allPanels } actualPanel={ this.props.actualPanel } />
                        :
                        ''
                    }
                    <Divider/>
                    <span style={{ color: '#aaa '}}>
                        Fetched all panels: { this.props.allPanels.length } &nbsp;
                        Fetched single panel: { this.props.actualPanel.length } &nbsp;
                        Fetched requests: { this.props.allRequests.length } &nbsp;
                        Fetched panel changes: { this.props.allPanelChanges.length } &nbsp;
                        Fetched single requests: { this.props.requests.length } &nbsp;
                        Fetched single panel changes: { this.props.panelChanges.length }                        
                    </span>
				</Segment>
	}
}